<template>

</template>

<script setup>
import {toRef, getCurrentInstance, onBeforeMount} from "vue";
import {usePageinfo} from "@/stores/pageinfo";

const props = defineProps(["hid"])

const pageInfoRef = toRef(usePageinfo())
const { proxy } = getCurrentInstance()

onBeforeMount(() => {
    if (null == props.hid){
        proxy.$router.push({
            name: "index"
        })
    }else{
        pageInfoRef.value.inviteHallId = props.hid

        proxy.$router.push({
            path: `/hall/${props.hid}`
        })
    }
})

</script>

<style scoped>

</style>